'use strict';
/**
 * A service to get and edit tracked moods on the site
 */

angular.module('msTracker').service('moodTrackerSvc', ['httpSvc', '$q', '$sessionStorage', 'moodTrackerDataMappingSvc', 'NotifyingSvc', 'languageSvc', function (httpSvc, $q, $sessionStorage, moodTrackerDataMappingSvc, NotifyingSvc, languageSvc) {

  function getTrackerById(trackerId) {
    return httpSvc.get('/apiproxy/user/tracker/' + trackerId);
  }

  function getWeeklyData(sliderId, timezone, page) {
    return httpSvc.get('/apiproxy/user/mood/day/' + sliderId + '?tz=' + timezone + '&limit=7&page=' + page);
  }

  function getMonthlyData(sliderId, timezone, page) {
    return httpSvc.get('/apiproxy/user/mood/day/' + sliderId + '?tz=' + timezone + '&limit=31&page=' + page);
  }

  function getYearlyData(sliderId, timezone, page) {
    return httpSvc.get('/apiproxy/user/mood/month/' + sliderId + '?tz=' + timezone + '&limit=12&page=' + page);
  }

  function getDateRange(startDate, endDate) {
    startDate = moment(startDate);
    var startDateParam = startDate.clone().subtract(1, 'day').format('YYYY-MM-DD');
    endDate = moment(endDate);
    var endDateParam = endDate.clone().add(1, 'day').format('YYYY-MM-DD');
    return httpSvc.get('/apiproxy/user/tracker/moods?startDate=' + startDateParam + '&endDate=' + endDateParam).then(function (result) {
      _.forEach(result, function (trackerData) {
        trackerData.trackerEntries = moodTrackerDataMappingSvc.filterForDateRange(trackerData.trackerEntries, startDate, endDate);
      });

      return result;
    });
  }

  function getOnboardingMoods() {
    return httpSvc.get('/apiproxy/user/mood/sliders/onboarding').then(function (data) {
      return _.sortBy(data, 'position');
    });
  }

  var cachedMoods = void 0,
      cachedLanguage = void 0;

  function getTrackedMoods() {
    var deferred = $q.defer();
    var currentLanguage = languageSvc.getLanguage();
    if (cachedMoods && currentLanguage === cachedLanguage) {
      deferred.resolve(cachedMoods);
    } else {
      httpSvc.get('/apiproxy/user/tracker/moods/tracked').then(function (data) {
        cachedMoods = _.sortBy(data, 'position');
        cachedLanguage = languageSvc.getLanguage();
        deferred.resolve(cachedMoods);
      });
    }
    return deferred.promise;
  }

  function updateTrackedMoods() {
    cachedMoods = undefined;
    getTrackedMoods().then(function () {
      return NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.REFRESH_TRACKER);
    });
    // notify other controllers to get new data.
  }

  function getAllMoods() {
    return httpSvc.get('/apiproxy/user/tracker/moods/tracked?all=true').then(function (data) {
      return _.sortBy(data, 'position');
    });
  }

  function getMoodEntryById(id) {
    return httpSvc.get('/apiproxy/user/mood/' + id);
  }

  function deleteTrackedMood(id) {
    return httpSvc.delete('/apiproxy/user/tracker/moods/' + id).then(function (result) {
      updateTrackedMoods();
      return result;
    });
  }

  function addTrackedMood(id) {
    return httpSvc.put('/apiproxy/user/tracker/moods/', [id]).then(function (result) {
      updateTrackedMoods();
      return result;
    });
  }

  function saveMoods(moods, messageId, message) {
    if (moods.length === 0) {
      return $q.resolve();
    }
    var counter = 0,
        moodsToSave = [];

    while (moods[counter]) {

      moodsToSave.push({
        id: moods[counter].entryId,
        moodSliderId: moods[counter].id,
        value: moods[counter].moodValue * 50 + 50,
        createdOn: moment()
      });
      counter++;
    }

    return httpSvc.post('/apiproxy/user/mood/newmoods', {
      'moodSliderEntries': moodsToSave,
      'messageId': messageId,
      'message': message
    }).then(function (authResponse) {
      if (authResponse && authResponse.requirements) {
        if (!$sessionStorage.authRequirements) {
          $sessionStorage.authRequirements = authResponse.requirements;
        } else {
          $sessionStorage.authRequirements = _.unionWith($sessionStorage.authRequirements, authResponse.requirements, function (o, n) {
            return o.requirementType === n.requirementType;
          });
        }
      }
      return authResponse;
    });
  }

  // If the 'login2' tracker has a value of -0.5 or less, this will be a low mood session.
  function hasLowMood(moodValues) {
    for (var i = moodValues.length - 1; i >= 0; i--) {
      if (moodValues[i].tracker.name === 'login2' && moodValues[i].value <= -0.5) {
        return true;
      }
    }
    return false;
  }

  function saveMood(mood, messageId, message) {
    mood.value = mood.value * 50 + 50;
    return httpSvc.post('/apiproxy/user/mood/newmoods', {
      'moodSliderEntries': [mood],
      'messageId': messageId,
      'message': message
    });
  }

  return {
    getTrackerById: getTrackerById,
    getWeeklyData: getWeeklyData,
    getMonthlyData: getMonthlyData,
    getYearlyData: getYearlyData,
    getDateRange: getDateRange,
    getOnboardingMoods: getOnboardingMoods,
    getTrackedMoods: getTrackedMoods,
    updateTrackedMoods: updateTrackedMoods,
    getAllMoods: getAllMoods,
    getMoodEntryById: getMoodEntryById,
    deleteTrackedMood: deleteTrackedMood,
    addTrackedMood: addTrackedMood,
    saveMoods: saveMoods,
    saveMood: saveMood,
    hasLowMood: hasLowMood
  };
}]);